import { defineMessages } from "react-intl";

export const remediationMessages = defineMessages({
  remediationComplexity: {
    defaultMessage: "Remediation complexity",
    id: "common-messages.remediationComplexity",
  },
  remediationComplexityLow: {
    defaultMessage: "Low",
    id: "common-messages.remediationComplexityLow",
  },
  remediationComplexityMedium: {
    defaultMessage: "Medium",
    id: "common-messages.remediationComplexityMedium",
  },
  remediationComplexityHigh: {
    defaultMessage: "High",
    id: "common-messages.remediationComplexityHigh",
  },
});
